document.addEventListener('DOMContentLoaded', function() {
  // Get references to your variant selectors
  const cableLengthRadios = document.querySelectorAll('input[name="Cable Length"]');
  const bracketModelRadios = document.querySelectorAll('input[name="Bumpbar Bracket"]');
  const orientationRadios = document.querySelectorAll('input[name="Overlay Insert Orientation"]');
  
  // Define the compatible options
  const compatibilityMap = {
    'SB-5': ['Horizontal'],
    'SB-3': ['Horizontal'],
    'SB-6': ['Horizontal'],
    'SB-7': ['Vertical'],
    'None': ['Horizontal', 'Vertical']
  };

  function updateOrientation(selectedBracketModel) {
    const compatibleOrientations = compatibilityMap[selectedBracketModel];
    const selectedOrientation = document.querySelector('input[name="Overlay Insert Orientation"]:checked').value;

    if (!compatibleOrientations.includes(selectedOrientation)) {
      // Select the first compatible orientation
      for (let radio of orientationRadios) {
        if (compatibleOrientations.includes(radio.value)) {
          radio.checked = true;
          break;
        }
      }
    }
  }

  function updateBracketModel(selectedOrientation) {
    const compatibleBracketModels = Object.keys(compatibilityMap).filter(model => compatibilityMap[model].includes(selectedOrientation));
    const selectedBracketModel = document.querySelector('input[name="Bumpbar Bracket"]:checked').value;

    if (!compatibleBracketModels.includes(selectedBracketModel)) {
      // Select the first compatible bracket model
      for (let radio of bracketModelRadios) {
        if (compatibleBracketModels.includes(radio.value)) {
          radio.checked = true;
          break;
        }
      }
    }
  }

  // Listen for changes in the bracket model selector
  bracketModelRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const selectedBracketModel = document.querySelector('input[name="Bumpbar Bracket"]:checked').value;
      updateOrientation(selectedBracketModel);
    });
  });

  // Listen for changes in the orientation selector
  orientationRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const selectedOrientation = document.querySelector('input[name="Overlay Insert Orientation"]:checked').value;
      updateBracketModel(selectedOrientation);
    });
  });

  // Initial update on page load
  const initialBracketModel = document.querySelector('input[name="Bumpbar Bracket"]:checked').value;
  updateOrientation(initialBracketModel);
});
